import {
  AdvancedMarker,
  InfoWindow,
  Pin,
  useAdvancedMarkerRef,
} from "@vis.gl/react-google-maps";
import { useMemo, useState } from "react";
import { glyphTypes } from "../DedicatedDispatchConstants";

export const CustomMarker = ({
  pointOfInterest,
  color = "rgb(255,40,20)",
  glyphColor = "#000",
  customGlyphColor = "red",
  pinBorderColor = "#000",
  hovered,
  hoveredColor = "rgb(255,0,255)",
  handleAssignOrders,
  clickable,
}) => {
  // console.log(hovered);
  const [infoWindowOpen, setInfoWindowOpen] = useState(false);
  const [markerRef, marker] = useAdvancedMarkerRef();
  // console.log("point of interest", pointOfInterest);

  const markerToRender = useMemo(() => {
    // console.log("this marker re-rendered", pointOfInterest.data);
    return (
      <AdvancedMarker
        ref={markerRef}
        clickable={clickable} //Doesn't work?
        onClick={() => {
          clickable && setInfoWindowOpen((prev) => !prev); //workaround for clickable prop not working
        }}
        key={pointOfInterest.data.address}
        position={pointOfInterest.location}
      >
        {infoWindowOpen && (
          <InfoWindow
            anchor={marker}
            maxWidth={300}
            minWidth={300}
            onCloseClick={() => setInfoWindowOpen(false)}
            headerContent={
              <div className="h6">{pointOfInterest.data.name}</div>
            }
          >
            {pointOfInterest.data.address}
            <br />
            <br />
            <div className="tw-flex tw-justify-between tw-items-center">
              {pointOfInterest.data.numOrders &&
                `${pointOfInterest.data.numOrders}${
                  pointOfInterest.assigned ? "" : " unassigned"
                } order${pointOfInterest.data.numOrders > 1 ? "s" : ""}`}
              {!pointOfInterest.assigned && (
                <button
                  className="btn btn-small btn-primary"
                  onClick={() => {
                    handleAssignOrders(
                      pointOfInterest.data.orders.map((order) => {
                        return order.order;
                      })
                    );
                  }}
                >
                  Assign All
                </button>
              )}
            </div>
            {!pointOfInterest.assigned && (
              <div
                className="border rounded mt-1"
                style={{ maxHeight: "160px", overflow: "auto" }}
              >
                {pointOfInterest?.data?.orders?.map((order) => {
                  return (
                    <div
                      key={order.deliveryId}
                      className="d-flex justify-content-between align-items-center p-1 border-bottom remove-last-item-border"
                    >
                      <div className="font-600 ml-1">{order.invoiceNumber}</div>
                      <div>
                        <button
                          className="btn btn-primary btn-small"
                          onClick={() => {
                            // console.log("assign through marker click");
                            handleAssignOrders([order.order]);
                          }}
                        >
                          Assign
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </InfoWindow>
        )}
        <Pin
          background={hovered ? hoveredColor : color}
          // glyph={"" + pointOfInterest.key}
          glyphColor={hovered ? hoveredColor : glyphColor}
          borderColor={pinBorderColor}
          scale={
            hovered
              ? pointOfInterest.hoveredSize ?? 1.5
              : pointOfInterest.size ?? 1.2
          }
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "200000px",
              color: hovered ? hoveredColor : customGlyphColor,
              width: "18px",
              height: "18px",
              transition: "transform .5s",
              transform: `scale(${hovered ? 1.3 : 1})`,
              // textAlign: "center",
              display: "grid",
              placeContent: "center",
              fontSize: ".8rem",
              fontWeight: "600",
            }}
          >
            {pointOfInterest?.glyphType
              ? glyphTypes[pointOfInterest.glyphType].glyph
              : pointOfInterest.glyph}
          </div>
        </Pin>
      </AdvancedMarker>
    );
  }, [
    hovered == true,
    infoWindowOpen,
    markerRef,
    handleAssignOrders,
    pointOfInterest.glyph,
    clickable,
  ]); //why does this work but not just [hovered]. Is it because somehow react thinks the props are changing even if it is a primitive boolean? And in this way it is not based on whether the prop changed or not but the final value being calculated to true/false and whether that is different from the last re-render?

  if (pointOfInterest.isError) {
    return null;
  }

  return markerToRender;
};
